import { render, staticRenderFns } from "./OrderNotFound.vue?vue&type=template&id=a6f04b3c"
import script from "./OrderNotFound.vue?vue&type=script&lang=js"
export * from "./OrderNotFound.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports